var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.19 5.081a1 1 0 0 1 .787 1.838l-5.424 2.325q-.474.203-.97.303v3.166l4.848 7.757a1 1 0 0 1-1.637 1.144l-.059-.084-4.152-6.644-4.152 6.644a1 1 0 0 1-1.696-1.06l4.848-7.757V9.547a5 5 0 0 1-.97-.303L5.19 6.92a1 1 0 1 1 .788-1.838L11.4 7.405a3 3 0 0 0 2.364 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.787 2.01a2 2 0 1 1-.408 3.98 2 2 0 0 1 .408-3.98"
  })));
};
export default Svg24;